import { render, staticRenderFns } from "./gameGift.vue?vue&type=template&id=172c22c0&scoped=true&"
import script from "./gameGift.vue?vue&type=script&lang=js&"
export * from "./gameGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172c22c0",
  null
  
)

export default component.exports